import axios from "axios";
import Base64 from "./base64";
import Config from "../constantes/Config";
import SessaoStore from "../stores/SessaoStore";
import FetchStore from "../stores/FetchStore";

const restapi = axios.create({
  baseURL: Config.API_URL,
  timeout: Config.TIMEOUT_DEFAULT,
  validateStatus: status => status < 500
});

const contains = (src, index) => {
  if (!src) {
    return false;
  }
  return src.toString().indexOf(index) !== -1;
};

const handleRequest = response => {
  FetchStore.fetchOff();

  if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
    if (response.status === 401) {
      // window.location.href = "/#/login";
      return { erro: "Sessão expirada! Você deverá fazer o login novamente." };
    }

    const erro = response.data.message || "Ocorre erro ao tentar se comunicar com o servidor.";
    const code = response.data.code || 0;
    return Promise.resolve({ erro, code });
  }

  return Promise.resolve(response.data);
};

const handleErros = error => {
  FetchStore.fetchOff();

  if (contains(error, "timeout")) {
    return Promise.resolve({ erro: "Serviço indisponível no momento" });
  }

  return Promise.resolve({
    erro: "Erro ao processar a requisição, verifique a conexão e tente novamente"
  });
};

const timeout = promise => {
  const ms = Config.TIMEOUT_DEFAULT;
  FetchStore.fetchOn();
  return new Promise((resolve, reject) => {
    setTimeout(() => reject(new Error("timeout")), ms);
    promise.then(resolve, reject);
  })
    .then(handleRequest)
    .catch(handleErros);
};

const basic = (id, secret) => {
  const encoded = Base64.encode(`${id}:${secret}`);

  return `Basic ${encoded}`;
};

const bearer = () => `Bearer ${SessaoStore.token}`;

const currentToken = () => ({
  Authorization: bearer()
});

const api = path => `${Config.API_CONTEXT}${path}`;

const get = (endpoint, config = {}) => timeout(restapi.get(api(endpoint), { headers: currentToken(), ...config }));

const post = async (endpoint, body, config = {}) => timeout(restapi.post(api(endpoint), body, { headers: currentToken(), ...config }));

const put = (endpoint, body, config = {}) => timeout(restapi.put(api(endpoint), body, { headers: currentToken(), ...config }));

const del = (endpoint, config = {}) => timeout(restapi.delete(api(endpoint), { headers: currentToken(), ...config }));

export default {
  get,
  post,
  put,
  del,
  basic,
  bearer
};



// WEBPACK FOOTER //
// ./src/services/request.js